import React, { useState, useContext, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import axios from "axios";
import moment from "moment";
import fileDownload from "js-file-download";
import { Collapse } from "react-bootstrap";
import "./YearlyCommonDashboard.css";
import { LoaderContext, getContext } from "../../../../Helpers/Context/Context";
import { APICall } from "../../../../Helpers/Network/APICalls";
import {
  CommonDropdownData,
  GetNewMemberDetailsYearWiseDashboard,
  GetFinancialYearDropdown,
  DividentNEFTToCSV,
  InsertYearlyWarrentReport,
} from "../../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../../Helpers/Enums/ApiStatus";
import { fetchAuthToken } from "../../../../Helpers/Network/OAuthHandler";
import notify, { ToastType } from "../../../../Helpers/ToastNotification";
import SelectForm from "../../../../Components/SelectForm/SelectForm";
import DynamicGrid from "../../../../Components/DynamicGrid/DynamicGrid";
import { MONTHSLIST, STARTYEAR } from "../../../../Helpers/Enums/Enum";
import { DB_DATE_DISPLAY_FORMAT } from "../../../../Helpers/Constants/Constants";
import MultiSelect from "../../../../Components/SelectForm/MultiSelect";
import { RoleEnum } from "../../../../Helpers/Enums/RoleEnum";

Modal.setAppElement("#root"); // Use the selector for your root element

const YearlyCommonDashboard = (props) => {
  const { PageName, UploadExcel, ExportToExcelUrl, ExcelImport, openModal } =
    props;

  let navigate = useNavigate();
  const [financialYearIdForDownload, setFinancialYearIdForDownload] = useState(null);
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [searchText, setSearchText] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [unitCodeOptions, setUnitCodeOptions] = useState([]);
  const [unitcode, setUnitCode] = useState([]);
  const [dashboardFilterOn, setDashboardFilterOn] = useState(false);
  const [financialYearOptions, setFinancialYearOptions] = useState([]);
  const [month, SetMonth] = useState();
  const [financialYear, setFinancialYear] = useState(null);
  const [financialYearId, setFinancialYearId] = useState(null);
  // const [months, setMonths] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const [OpenUniCodeModal, setOpenUniCodeModal] = useState(false);
  const [fyear, SetFyear] = useState(null);
  // const [month, SetMonth] = useState();
  const [formErrors, setFormErrors] = useState<any>({});
  const [FinancialYear, SetFinancialYear] = useState(null);
  const isAdmin = context?.CurrentRoleId === RoleEnum.Admin;
  const isInternalTeam = context?.CurrentRoleId === RoleEnum.InternalTeam;
  let MemberId = context.MemberId;

  useEffect(() => {
    showLoader();
    getDropDownDataApiCall();
    hideLoader();
  }, []);

  useEffect(() => {
    showLoader();
    getDashboardData("");
    hideLoader();
  }, [start, sortColumn, sortDirection, searchText, count]);

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "FinancialYear") {
      setFinancialYear(event);
      setFinancialYearId(event.value);
    }
    // if (apiFieldName === "Months") {
    //   setMonths(event);
    // }
    if (apiFieldName === "UnitCode") {
      setUnitCode(event);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        unitcode_isEmpty: "",
      }));
    }
  };

  const generateFinancialYearOptions = async () => {
    showLoader();
    const result = await APICall(GetFinancialYearDropdown, {});
    const yearOptions = result.Data?.map((item) => ({
      label: item.FinancialYear,
      value: item.Id,
    }));
    if (result?.Data?.length > 0) {
      setFinancialYearOptions(yearOptions);
    }
    hideLoader();
  };

  const getDropDownDataApiCall = async () => {
    await generateFinancialYearOptions();
    showLoader();
    let requestParams;

    if (isAdmin) {
      requestParams = {
        dropdownName: "unitcodedd",
      };
    } else if (isInternalTeam) {
      requestParams = {
        dropdownName: "unitcodeInternalTeam",
        UserRoleId: context.Id,
      };
    }
    const res = await APICall(CommonDropdownData, requestParams);

    if (res.Status === ApiStatus.OK && res.Data.length > 0) {
      let options = await res.Data;
      await setUnitCodeOptions(options);
      hideLoader();
    } else {
      await setUnitCodeOptions([]);
      hideLoader();
    }
    hideLoader();
  };

  // Check validation to filled with value
  const CheckValidation = async () => {
    let objError: any = {};
    let error = false;
    setFormErrors({});

    if (!unitcode || unitcode == null || unitcode.length <= 0) {
      error = true;
      objError["unitcode_isEmpty"] = "Unit code can not be empty";
    }
    else{
      error = false;
      objError["unitcode_isEmpty"] = "";
    }
    setFormErrors(objError);
    return error;
  };

  const exportToExcelFunction = async () => {
    let IsInValid = await CheckValidation();
    if (IsInValid == false) {
      showLoader();
      const params = {
        DashboardType: PageName,
        MemberID: context.MemberId,
        RoleID: context.CurrentRoleId,
        FinancialYear: fyear,
        UnitCode:
          unitcode && unitcode.length > 0
            ? unitcode.map(({ value }) => value).toString()
            : " ",
        CreatedBy: context.MemberId,
        ModifiedBy: context.MemberId,
      };
      let token = await fetchAuthToken();
      axios
        .request({
          responseType: "blob",
          method: "POST",
          url: ExportToExcelUrl,
          data: params,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Headers": "*",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          

          // Extract the financial year and calculate the next year
          const financialYear = financialYearIdForDownload;
          // const nextYear = parseInt(financialYear) + 1;
  
          // Create the file name
          const fileName = `${PageName}_${financialYear}.xlsx`;
  
          // Download the file
          fileDownload(response.data, fileName);

          // console.log(response.data);
          // fileDownload(
          //   response.data,
          //   `${PageName}_Report_` +
          //     `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
          //     `.xlsx`
          // );
          hideLoader();
          setFormErrors({});
          setOpenUniCodeModal(false);
        })
        .catch((error) => {
         
          hideLoader();
          setFormErrors({});
          setOpenUniCodeModal(false);
          notify(ToastType.Error, "Failed to export data.");
        });
    }
  };

  const getDashboardData = async (btn) => {
    showLoader();
    let obj = {
      start: btn === "reset" ? 0 : start,
      resultsPerPage: btn === "reset" ? 10 : pageSize,
      searchText: btn === "reset" ? "" : searchText,
      sortColumn: btn === "reset" ? "" : sortColumn,
      sortDirection: btn === "reset" ? "" : sortDirection,
      FYId: btn === "reset" ? 0 : financialYearId ? financialYearId : 0,
      UnitCode:
        btn === "reset"
          ? ""
          : unitcode && unitcode.length > 0
          ? unitcode.map(({ value }) => value).toString()
          : "",
      DashboardType: PageName,
      // Month: btn === "reset" ? "" : (months && months.length > 0 ? months.map(({ value }) => value).toString() : ""),
      // start: start,
      // resultsPerPage: pageSize,
      // searchText: searchText,
      // sortColumn: sortColumn,
      // sortDirection: sortDirection,
      // FYId: financialYearId ? financialYearId : 0,
      // UnitCode:
      //   unitcode && unitcode.length > 0
      //     ? unitcode.map(({ value }) => value).toString()
      //     : " ",
      // DashboardType: PageName,
    };
    const resp = await APICall(GetNewMemberDetailsYearWiseDashboard, obj);

    if (resp?.Data?.length > 0) {
      setDashboardData(resp?.Data);
    } else {
      setDashboardData([]);
      hideLoader();
    }
    setCount(resp?.Data?.[0]?.TotalCount || resp?.Data?.length || 0);
    hideLoader();
  };

  const resetFunction = async () => {
    setFinancialYear(null);
    setFinancialYearId(null);
    setUnitCode([]);
    setSearchText("");
    setSortColumn("");
    setSortDirection("");
    setStart(0);
    setPageSize(10);
    setCount(0);
    setDashboardFilterOn(false);
    await getDashboardData("reset");
  };

  const onClickFunction = async (event, action) => {
    debugger
    if (action === "Apply") {
      let isEmptyReqObj = false;
      if (dashboardFilterOn === true) {
        let reqFilterObj = {
          FinancialYear: financialYearId ? financialYearId : 0,
          // Months:
          //   months && months.length > 0
          //     ? months.map(({ value }) => value).toString()
          //     : "",
          UnitCode:
            unitcode && unitcode.length > 0
              ? unitcode.map(({ value }) => value).toString()
              : "",
        };

        isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
          if (f === "" || f === null || f === undefined) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (isEmptyReqObj === true) {
        notify(1, "Select at least one filter.");
      } else {
        await getDashboardData("");
      }
    }
    // else if (action === "Reset") {
    //   await resetFunction();
    // }
  };

  const openUnitCodeModal = (fYear, Month,years,FinancialYears) => {
    setFormErrors({});
    SetFyear(fYear);
    SetFinancialYear(FinancialYears);
    // SetMonth(Month);
    setFinancialYearIdForDownload(years);
    setUnitCode(null);
    setOpenUniCodeModal(true);
  };

  const closeUniCodeModal = () => {
    setOpenUniCodeModal(false);
  };

  const exportToCSV = async () => {
    let IsInValid = await CheckValidation();
    if (IsInValid == false) {
      showLoader();
      const params = {
        FinancialYear: fyear,
        //FinancialYearS: financialYear,
        MonthS: month,
        // Month: month,
        DashboardType: PageName,
        UnitCode:
          unitcode && unitcode.length > 0
            ? unitcode.map(({ value }) => value).toString()
            : " ",
      };

      let token = await fetchAuthToken();

      axios
        .request({
          responseType: "blob",
          method: "POST",
          url: DividentNEFTToCSV,
          data: params,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Headers": "*",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
         
          // Extract the financial year and calculate the next year
          const financialYear = financialYearIdForDownload;
          fileDownload(
            response.data,
            `Dividend_NEFT_File_${financialYear}.txt`
          );
          hideLoader();
          setFormErrors({});
          setOpenUniCodeModal(false);
        })
        .catch((error) => {
          setOpenUniCodeModal(false);
          setFormErrors({});
          hideLoader();
         
          notify(ToastType.Error, "Failed to export data.");
        });
    }
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "FinancialYear",
      label: "Financial Year",
      options: {
        display: true,
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: { width: "400px" },
        }),
      },
    },
    // {
    //   name: "Month",
    //   label: "Month",
    //   options: {
    //     display: true,
    //     filter: false,
    //     sort: false,
    //     setCellProps: () => ({
    //       style: { width: "400px" },
    //     }),
    //   },
    // },
    {
      name: "ReportLink",
      label: "Report Link",
      options: {
        display: true,
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { width: "500px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          let Year = tableMeta.rowData[0];
          let Month = tableMeta.rowData[2];
          let Years = tableMeta.rowData[1];
          let FinancialYears = tableMeta.rowData[1];

          return (
            <>
              <a
                className="ReportLink"
                onClick={() => {
                  UploadExcel
                    ? openModal(Year, Month)
                    : openUnitCodeModal(Year, Month,Years,FinancialYears);
                }}
                style={{ cursor: "pointer" }}
              >
                {value}
              </a>
            </>
          );
        },
      },
    },
  ];

  return (
    <>
      <div className="form-main">
        <div className="page-title w-100">
          <div className="col-lg-12 p-0">
            <div className="row justify-content-end">
              <div className="col-lg-7 col-md-8 SearchBoxLocation pr-0">
                <div className="row d-flex ser_flx justify-content-end">
                  <div
                    className="float-right d-flex col-lg-5 col-md-6 justify-content-end pr-2 btns_mob"
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    {/* {UploadExcel && (
                      <Tooltip title="import to excel">
                        <button className="btn btn-submit" onClick={openModal}>
                          <i className="fa fa-upload"></i>
                        </button>
                      </Tooltip>
                    )} */}
                    <ul
                      className="float-right filter-icon  "
                      style={{ position: "relative" }}
                    >
                      <li
                        onClick={() =>
                          setDashboardFilterOn((current) => !current)
                        }
                        className="filter-btn"
                      >
                        <a className="filter-btn">
                          <i className="fa fa-filter"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="clearfix"></div>
        <Collapse in={dashboardFilterOn}>
          <div className="filter-content">
            <div className="row">
              <div className="col-lg-3 col-md-4 col-xs-12 mb-2">
                <div className="form-group">
                  <label className="col-form-label">Financial Year</label>
                  <SelectForm
                    options={financialYearOptions}
                    placeholder="Select Financial Year"
                    isDisabled={false}
                    value={financialYear}
                    onChange={(event: any) =>
                      selectOnChange(event, "FinancialYear")
                    }
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-lg-12 col-md-12"
                style={{ marginBottom: "25px" }}
              >
                <div className="float-right">
                  <button
                    className="btn btn-cancel"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => resetFunction()}
                  >
                    <i className="fas fa-undo"></i> Reset
                  </button>
                  <button
                    className="btn btn-submit"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => onClickFunction(e, "Apply")}
                  >
                    <i className="fas fa-check"></i> Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>

        <DynamicGrid
          options={Options}
          data={dashboardData}
          columns={GridColumns}
        />

        <div className="ModalSize">
          <Modal
            ariaHideApp={false}
            isOpen={OpenUniCodeModal}
            onRequestClose={closeUniCodeModal}
            contentLabel="Unit Codes"
            style={{
              content: {
                width: "30%", // Adjust this value as needed
                // height: "auto", // Adjust this value as needed
                //  margin: "auto", // Center the modal horizontally
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#ffffff",
                zIndex: "999",
              },
            }}
          >
            <div className="col-lg-12 p-0">
              <div className="row">
                <div
                  className="col-lg-12 col-md-12"
                  style={{ marginBottom: "15px" }}
                >
                  <div className="form-group">
                    <label className="col-form-label">Unit Code</label>
                    {/* <SelectForm
                      options={unitCodeOptions}
                      placeholder="Select Unit Code"
                      isDisabled={false}
                      value={unitcode}
                      onChange={(event: any) =>
                        selectOnChange(event, "UnitCode")
                      }
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    /> */}
                    <MultiSelect
                      key="example_id"
                      options={unitCodeOptions}
                      onChange={(selectedOptions) =>
                        selectOnChange(selectedOptions, "UnitCode")
                      }
                      value={unitcode}
                      isSelectAll={true}
                      menuPlacement={"bottom"}
                    />
                    <p style={{ color: "red" }}>
                      {formErrors["unitcode_isEmpty"]}
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-12 col-md-12"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <button
                    className="btn btn-submit"
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      if (PageName === "DividendNEFTFile") {
                        exportToCSV();
                      } else {
                        exportToExcelFunction();
                      }
                    }}
                  >
                    <i className="fas fa-paper-plane"></i> Submit
                  </button>
                  <button
                    className="btn btn-cancel"
                    onClick={closeUniCodeModal}
                  >
                    <i className="far fa-times-circle"></i> Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
        {UploadExcel && <ExcelImport />}
      </div>
    </>
  );
};

export default YearlyCommonDashboard;
